// Legal pages content - ported from thematrixunlocked.com legal pages
// Section content types: p = paragraph, ul = bullet list, lead = intro line before a list

export const LEGAL_PAGES = {
  "privacy-policy": {
    slug: "privacy-policy",
    title: "Privacy Policy",
    sections: [
      {
        heading: "1. Information We Collect",
        blocks: [
          {
            type: "p",
            text: 'Matrix Unlocked Management Consultancy FZCO ("we," "us," or "our") collects information you provide directly to us, such as when you create an account, subscribe to our or contact us for support.',
          },
          { type: "lead", text: "Information you provide to us:" },
          {
            type: "ul",
            items: [
              "Name, email address, and contact information",
              "Payment information (processed securely through third-party processors)",
              "Communications with us, including support requests",
              "Any other information you choose to provide",
            ],
          },
          { type: "lead", text: "Information we collect automatically:" },
          {
            type: "ul",
            items: [
              "Log data (IP address, browser type, pages visited)",
              "Device information and usage patterns",
              "Cookies and similar tracking technologies",
            ],
          },
        ],
      },
      {
        heading: "2. How We Use Your Information",
        blocks: [
          { type: "lead", text: "We use the information we collect to:" },
          {
            type: "ul",
            items: [
              "Provide, maintain, and improve our services",
              "Process transactions and send related information",
              "Send technical notices, updates, and support messages",
              "Respond to your comments and questions",
              "Communicate about products, services, and promotional offers",
              "Monitor and analyze trends and usage",
            ],
          },
        ],
      },
      {
        heading: "3. Information Sharing and Disclosure",
        blocks: [
          {
            type: "lead",
            text: "We do not sell, trade, or otherwise transfer your personal information to third parties except:",
          },
          {
            type: "ul",
            items: [
              "With your consent",
              "To comply with legal obligations",
              "To protect our rights and property",
              "With service providers who assist in our operations",
              "In connection with a merger, acquisition, or sale of assets",
            ],
          },
        ],
      },
      {
        heading: "4. Data Security",
        blocks: [
          {
            type: "p",
            text: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.",
          },
        ],
      },
      {
        heading: "5. Data Retention",
        blocks: [
          {
            type: "p",
            text: "We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.",
          },
        ],
      },
      {
        heading: "6. Your Rights",
        blocks: [
          {
            type: "lead",
            text: "Depending on your jurisdiction, you may have the right to:",
          },
          {
            type: "ul",
            items: [
              "Access and receive a copy of your personal information",
              "Rectify inaccurate personal information",
              "Request deletion of your personal information",
              "Object to or restrict processing of your information",
              "Data portability",
              "Withdraw consent where processing is based on consent",
            ],
          },
        ],
      },
      {
        heading: "7. Cookies and Tracking Technologies",
        blocks: [
          {
            type: "p",
            text: "We use cookies and similar tracking technologies to track activity on our service and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.",
          },
        ],
      },
      {
        heading: "8. Third-Party Services",
        blocks: [
          {
            type: "p",
            text: "Our service may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties.",
          },
        ],
      },
      {
        heading: "9. Children's Privacy",
        blocks: [
          {
            type: "p",
            text: "Our service is not intended for children under 18 years of age. We do not knowingly collect personal information from children under 18.",
          },
        ],
      },
      {
        heading: "10. International Data Transfers",
        blocks: [
          {
            type: "p",
            text: "Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place for such transfers.",
          },
        ],
      },
      {
        heading: "11. Changes to This Privacy Policy",
        blocks: [
          {
            type: "p",
            text: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.',
          },
        ],
      },
      {
        heading: "12. Contact Us",
        blocks: [
          {
            type: "p",
            text: "If you have any questions about this Privacy Policy, please contact us at ",
            email: "management@thematrixunlocked.com",
          },
        ],
      },
    ],
  },

  terms: {
    slug: "terms",
    title: "Terms of Service",
    sections: [
      {
        heading: "1. Agreement to Terms",
        blocks: [
          {
            type: "p",
            text: 'These Terms of Service ("Terms") govern your use of The Matrix Unlocked website and services operated by Matrix Unlocked Management Consultancy FZCO ("we," "us," or "our"). By accessing or using our service, you agree to be these Terms.',
          },
        ],
      },
      {
        heading: "2. Description of Service",
        blocks: [
          {
            type: "p",
            text: "The Matrix Unlocked provides trading education, algorithmic trading strategies, and related educational content. Our services include but are not limited to online courses, webinars, private consultations, and access to proprietary trading methodologies.",
          },
        ],
      },
      {
        heading: "3. User Accounts",
        blocks: [
          {
            type: "p",
            text: "When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for maintaining the confidentiality of your account.",
          },
        ],
      },
      {
        heading: "4. Prohibited Uses",
        blocks: [
          { type: "lead", text: "You may not use our service:" },
          {
            type: "ul",
            items: [
              "For any unlawful purpose or to solicit others to perform unlawful acts",
              "To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances",
              "To infringe upon or violate our intellectual property rights or the intellectual property rights of others",
              "To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate",
              "To submit false or misleading information",
            ],
          },
        ],
      },
      {
        heading: "5. Educational Nature",
        blocks: [
          {
            type: "p",
            text: "All content provided by The Matrix Unlocked is for educational purposes only. We do not provide investment advice, and our content should not be construed as such. Trading involves substantial risk and is not suitable for all investors.",
          },
        ],
      },
      {
        heading: "6. Intellectual Property Rights",
        blocks: [
          {
            type: "p",
            text: "The service and its original content, features, and functionality are and will remain the exclusive property of Matrix Unlocked Management Consultancy FZCO and its licensors. The service is protected by copyright, trademark, and other laws.",
          },
        ],
      },
      {
        heading: "7. Payment Terms",
        blocks: [
          {
            type: "p",
            text: "Payment for services must be made in advance. All fees are non-refundable except as required by law. We reserve the right to change our pricing at any time with notice.",
          },
        ],
      },
      {
        heading: "8. Termination",
        blocks: [
          {
            type: "p",
            text: "We may terminate or suspend your account and bar access to the service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever including without limitation if you breach the Terms.",
          },
        ],
      },
      {
        heading: "9. Limitation of Liability",
        blocks: [
          {
            type: "p",
            text: "In no event shall Matrix Unlocked Management Consultancy FZCO, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.",
          },
        ],
      },
      {
        heading: "10. Changes to Terms",
        blocks: [
          {
            type: "p",
            text: "We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.",
          },
        ],
      },
      {
        heading: "11. Contact Us",
        blocks: [
          {
            type: "p",
            text: "If you have any questions about these Terms of Service, please contact us at ",
            email: "management@thematrixunlocked.com",
          },
        ],
      },
    ],
  },

  disclaimer: {
    slug: "disclaimer",
    title: "Disclaimer",
    sections: [
      {
        heading: "1. General Risk Disclosure",
        blocks: [
          {
            type: "p",
            text: "Matrix Unlocked Management Consultancy FZCO provides educational content and trading strategies for informational purposes only. All content is strictly educational and should not be considered as investment advice, financial advice, or a recommendation to buy or sell any financial instrument.",
          },
        ],
      },
      {
        heading: "2. Trading Risks",
        blocks: [
          {
            type: "lead",
            text: "Trading in financial markets involves significant risks, including but not limited to:",
          },
          {
            type: "ul",
            items: [
              "Loss of Capital: You may lose some or all of your invested capital",
              "Market Volatility: Prices can fluctuate rapidly and unpredictably",
              "Leverage Risk: Leveraged trading can amplify both gains and losses",
              "Liquidity Risk: Inability to exit positions at desired prices",
              "Technical Risk: System failures or connectivity issues",
              "Regulatory Risk: Changes in laws and regulations",
            ],
            boldPrefix: true,
          },
        ],
      },
      {
        heading: "3. No Guarantee of Results",
        blocks: [
          {
            type: "p",
            text: "The Matrix Unlocked makes no representations or warranties that any trading strategy, algorithm, or methodology will be profitable or will not result in losses. Historical performance, backtesting results, or simulated performance are not reliable indicators of future results.",
          },
        ],
      },
      {
        heading: "4. Educational Purpose Only",
        blocks: [
          {
            type: "p",
            text: "All materials, courses, and strategies provided by The Matrix Unlocked are for educational purposes only. They are not intended as specific investment advice for any individual's particular circumstances.",
          },
        ],
      },
      {
        heading: "5. Professional Advice Recommendation",
        blocks: [
          { type: "lead", text: "Before making any trading decisions, you should:" },
          {
            type: "ul",
            items: [
              "Consult with a qualified financial advisor",
              "Carefully consider your financial situation and risk tolerance",
              "Only invest money you can afford to lose",
              "Understand the specific risks of your chosen trading instruments",
            ],
          },
        ],
      },
      {
        heading: "6. Algorithmic Trading Risks",
        blocks: [
          {
            type: "lead",
            text: "Algorithmic trading strategies carry additional risks:",
          },
          {
            type: "ul",
            items: [
              "Model Risk: Algorithms may not perform as expected in all market conditions",
              "Over-optimization: Strategies may be curve-fitted to historical data",
              "Technology Dependence: Reliance on technology systems and infrastructure",
              "Market Changes: Market dynamics may change, affecting algorithm performance",
            ],
            boldPrefix: true,
          },
        ],
      },
      {
        heading: "7. Testimonials and Case Studies",
        blocks: [
          {
            type: "p",
            text: "Any testimonials, case studies, or success stories presented are not typical and may not be representative of the experience of other users. Individual results vary significantly based on many factors including market conditions, experience, and capital allocation.",
          },
        ],
      },
      {
        heading: "8. Regulatory Considerations",
        blocks: [
          {
            type: "p",
            text: "The Matrix Unlocked is not a registered investment advisor, broker-dealer, or financial institution. We do not provide personalized investment advice or recommendations for specific securities or trading strategies.",
          },
        ],
      },
      {
        heading: "9. International Trading",
        blocks: [
          {
            type: "lead",
            text: "If you are trading in international markets, you may be subject to additional risks including:",
          },
          {
            type: "ul",
            items: [
              "Currency exchange rate fluctuations",
              "Different regulatory environments",
              "Political and economic instability",
              "Time zone differences affecting market access",
            ],
          },
        ],
      },
      {
        heading: "10. Psychological Factors",
        blocks: [
          {
            type: "lead",
            text: "Trading can be emotionally challenging and may lead to:",
          },
          {
            type: "ul",
            items: [
              "Stress and anxiety",
              "Impulsive decision-making",
              "Overconfidence or fear",
              "Addiction-like behaviors",
            ],
          },
        ],
      },
      {
        heading: "11. Due Diligence",
        blocks: [
          { type: "lead", text: "You are responsible for:" },
          {
            type: "ul",
            items: [
              "Conducting your own research and analysis",
              "Verifying all information independently",
              "Understanding the terms and conditions of your broker",
              "Staying informed about market conditions and regulatory changes",
            ],
          },
        ],
      },
      {
        heading: "12. Limitation of Liability",
        blocks: [
          {
            type: "p",
            text: "Matrix Unlocked Management Consultancy FZCO, its officers, directors, employees, and affiliates shall not be liable for any trading losses, damages, or claims arising from the use of our educational materials or strategies.",
          },
        ],
      },
      {
        heading: "12. Acknowledgment",
        blocks: [
          {
            type: "p",
            text: "By using Matrix Unlocked Management Consultancy FZCO services, you acknowledge that you have read, understood, and agree to this risk disclaimer. You accept full responsibility for your trading decisions and any resulting gains or losses.",
          },
        ],
      },
    ],
  },
};
